import { Theme } from '@mui/material';

/**
 * Where the row's two arrows sit, as the board draws them: a 32px round button centred on the
 * row's edge, so half of it hangs outside the row. The inner half covers only the outer edge of
 * the card at that end (the row's 4px edge padding and the card's 12px of padding), never what is
 * drawn inside the card. The row's own scrolling box does not hold the arrows, so it cannot clip
 * the outer half. On a phone that half is in the page's own gutter.
 */

/** The arrow's width and height. */
export function arrowSize(theme: Theme): string {
  return theme.semantic.size['6xs'];
}

/**
 * How far an arrow hangs outside the row: half its size. Worked out from the size, not read from
 * a second token that must be kept equal to half of it by hand.
 */
export function arrowOverhang(theme: Theme): string {
  return `calc(${arrowSize(theme)} / 2)`;
}

/**
 * The room the right arrow's outer half takes beside the pinned new-one card (desktop), on top of
 * the gap the card has beside the last identity card. The pinned card sits an `sm` step clear of
 * the arrow's outer edge, with the divider between them. The row sets this room aside in both
 * states, so the width of a card does not depend on whether the row overflows: while the cards fit
 * it is left empty at the row's end.
 */
export function pinnedClearance(theme: Theme): string {
  return `calc(${arrowOverhang(theme)} + ${theme.semantic.spacing['2xs']})`;
}
